module.exports = __webpack_public_path__ + "iframe-page-default.5294d857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/iframe-page-default.png
// module id = 1423
// module chunks = 0